import React, {useState, useEffect} from 'react'
import MeetingShowContainer from './MeetingShowContainer'
import BookingList from './BookingList'
import Confirm, {CONFIRM_YES} from '../../components/Confirm/Confirm'
import styled from 'styled-components'
import {
  fetchRoomReservation,
  cancelRoomReservation,
  cancelRecurringRoomReservation
} from '../../api/reservations'
import Header from '../../components/Header/Header'
import Clock from '../../components/Clock/Clock'
import HeaderTitle from '../../components/Header/HeaderTitle'
import HeaderButton from '../../components/Header/HeaderButton'
import {useUIDispatch} from '../../context/UIContext'
import {_L, useLocaleState} from '../../context/LocaleContext'

const Container = styled.div`
  height: 100vh;
  width: 100vw;
`

const MeetingSpaceShowMeeting = ({room, parentPage}) => {
  const [showConfirm, setShowConfirm] = useState(false)
  const [reservation, setReservation] = useState({occurrences: []})

  const uiDispatch = useUIDispatch()
  const localeState = useLocaleState()

  useEffect(
    () => {
      fetchRoomReservation(room).then(reservation => setReservation(reservation))
    },
    [room]
  )

  const onCancel = resId => {
    // remove the occurrence date

    if (resId > 0) {
      // check if this is a regular reservation or last occurrence
      let numberOfOccurrences = reservation.occurrences.length

      cancelRoomReservation({resId}).then(() => {
        if (numberOfOccurrences === 1) {
          uiDispatch({type: 'setContent', payload: {content: parentPage}})
        } else {
          // Refresh the b
          fetchRoomReservation(room).then(reservation => {
            setReservation(reservation)
          })
        }
      })
    } else {
      console.log('Reservation not found for date')
    }
  }

  const onCancelAll = () => setShowConfirm(true)

  const onConfirm = response => {
    if (response === CONFIRM_YES) {
      // We need the resId value of the first reservation in the sequence.
      const resId = Math.min(
        ...reservation.occurrences.map(item => parseInt(item.resId))
      )

      cancelRecurringRoomReservation({
        resId,
        comments: '',
        cancelMeeting: true
      }).then(() =>
        uiDispatch({type: 'setContent', payload: {content: parentPage}})
      )
    }

    setShowConfirm(false)
  }

  const onHeaderCancel = () =>
    uiDispatch({type: 'setContent', payload: {content: parentPage}})

  const {occurrences} = reservation
  const hasMultipleOccurrences = occurrences && occurrences.length > 1

  return (
    <Container>
      <Header
        leftContent={<Clock />}
        centerContent={
          <HeaderTitle
            title={_L({key: 'Meeting Space Booking', localeState})}
          />
        }
        rightContent={
          <HeaderButton
            label={_L({key: 'Cancel', localeState})}
            onClick={onHeaderCancel}
          />
        }
      />
      <MeetingShowContainer
        room={room}
        showCancelAll={hasMultipleOccurrences}
        onBack={onCancelAll}
        buttonBack={_L({key: 'X Cancel entire series', localeState})}
      >
        <BookingList onCancel={onCancel} reservation={reservation} />
        <Confirm
          title={_L({key: 'Cancel Reservations', localeState})}
          message={_L({
            key: 'Are you sure you want to cancel this reservation ?',
            localeState
          })}
          onConfirm={onConfirm}
          isOpen={showConfirm}
        />
      </MeetingShowContainer>
    </Container>
  )
}

export default MeetingSpaceShowMeeting
